import * as React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import { Page, PageHeader } from '../components/common';
import { SectionMain } from '../components/sections';
import { Button } from '../components/buttons';
import { bindActionCreators } from 'redux';
import authActions from '../auth/authActions';

import FileUpload from '../components/forms/FileUpload';

// tslint:disable
interface MarkPageProps {
	actions: any;
	history: any;
}
class MarkPage extends React.Component<MarkPageProps, any> {

	authAPIClick = (e: any) => {
		const apiUrl = process.env.REACT_APP_API_URL;
		console.log(axios.defaults.headers);		
		axios.get(`${apiUrl}/helloAuth`)
		.then(response => {
			console.log(response.data);
		});
	}
	customerAPIClick = (e: any) => {
		const apiUrl = process.env.REACT_APP_API_URL;
		console.log(axios.defaults.headers);		
		axios.get(`${apiUrl}/helloAuth/customeronly`)
		.then(response => {
			console.log(response.data);
		});
	}
	adminAPIClick = (e: any) => {
		const apiUrl = process.env.REACT_APP_API_URL;
		console.log(axios.defaults.headers);		
		axios.get(`${apiUrl}/helloAuth/adminonly`)
		.then(response => {
			console.log(response.data);
		});
	}
	logOut = (e: any) => {
		this.props.actions.logout()
		.then(() => this.props.history.push(`/quote/success`));
	}
	refreshToken = (e: any) => {
		// this.props.actions.refreshToken()
		// .then((response: any) => {
		// 	console.log(response);
		// });
		console.log('could not get a refresh token to work');
	}

	onUpload = (file: any) => {
		console.log(file);
	}

	public render(): JSX.Element {
		return (		
		<Page title="Pick list types">
			<PageHeader title="Mark Test Page" className="page-header-sm" />
			<SectionMain sectionClassName="section-lg">
				<Button onClick={this.authAPIClick}>Auth API</Button>
				<br />
				<Button onClick={this.customerAPIClick}>Customer Only API</Button>
				<br />
				<Button onClick={this.adminAPIClick}>Admin Only API</Button>
				<br />
				<Button onClick={this.logOut}>Logout</Button>
				<br />
				<Button onClick={this.refreshToken}>Refresh Token</Button>
				<br />
				<FileUpload label="Upload Signed Form" onDrop={this.onUpload} />
			</SectionMain>
		</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		auth: state.auth
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MarkPage as any);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/dev/MarkPage.tsx